module.exports = __webpack_public_path__ + "static/img/bannerb.ee5aeb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bannerb.jpg
// module id = H1/Z
// module chunks = 1